import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, withKeys as _withKeys, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3de3e2c5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modal-window-container" }
const _hoisted_2 = { class: "modal-window shadow-deep" }
const _hoisted_3 = { class: "modal-window-header level is-mobile has-background-modest" }
const _hoisted_4 = { class: "has-text-contents-title has-text-title level is-mobile" }
const _hoisted_5 = { class: "modal-window-body has-background-page" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ButtonIcon = _resolveComponent("ButtonIcon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("header", _hoisted_3, [
        _createElementVNode("h1", _hoisted_4, _toDisplayString(_ctx.heading), 1),
        (_ctx.hasClose)
          ? (_openBlock(), _createBlock(_component_ButtonIcon, {
              key: 0,
              styled: "is-none",
              icon: "xmark-circle",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close'))),
              onKeydown: _cache[1] || (_cache[1] = _withKeys(_withModifiers(($event: any) => (_ctx.$emit('close')), ["prevent"]), ["space","enter"])),
              "aria-label": `${_ctx.heading} ${_ctx.$t('label.dialogClose')}`
            }, null, 8, ["aria-label"]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _renderSlot(_ctx.$slots, "default", {}, undefined, true)
      ])
    ])
  ]))
}